
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy, Link } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The timeline displays concurrent and/or sequential items visually on a time
  axis.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/Timeline/Timeline2.jpg" srcset="https://inno-ecl.s3.amazonaws.com/media/images/EC/Timeline/Timeline%20-%20Mobile2.jpg 598w, https://inno-ecl.s3.amazonaws.com/media/images/EC/Timeline/Timeline2.jpg 734w" alt="Anatomy of timeline" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <h3>{`Default`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading of the item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Timestamp`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Timestamp when the item happened (or is scheduled to)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Details`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A more detailed description. Can include text, links, media files`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Conditional`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Expand button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Actionable button to display the full list of items in the timeline - to be used `}<strong parentName="td">{`if`}</strong>{` there are over 12 items in the timeline`}<br /><strong parentName="td">{`Position`}</strong>{`: under the 3rd item`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`label each item`}</strong>{` with a short, distinct and indicative heading`}</li>
      <li parentName="ul"><strong parentName="li">{`order`}</strong>{` items sequentially`}</li>
      <li parentName="ul"><strong parentName="li">{`always`}</strong>{` display the `}<strong parentName="li">{`timestamp and heading`}</strong>{` for each item`}</li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul">{`don't use when there are `}<strong parentName="li">{`less than 3 items`}</strong>{` - use list instead`}</li>
      <li parentName="ul">{`don't use when `}<strong parentName="li">{`all the items start at the same time`}</strong></li>
      <li parentName="ul">{`don't `}<strong parentName="li">{`place items in an order that isn't sequential`}</strong></li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`when you want to present multiple consecutive items (events, occurrences, agendas, etc) visually`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`don't use for `}<strong parentName="li">{`actions or to indicate steps`}</strong>{` that need to be taken - use `}<Link to="/eu/components/list/usage/" mdxType="Link">{`ordered list`}</Link>{` instead`}</li>
    </ul>
    <h2>{`Notes`}</h2>
    <h3>{`Design`}</h3>
    <p>{`Make sure the correct `}<strong parentName="p">{`color scheme`}</strong>{` is followed:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Black`}</strong>{` for heading, description, timestamp, title and details`}</li>
      <li parentName="ul"><strong parentName="li">{`Blue`}</strong>{` with underline for hyperlinks in items' details`}</li>
      <li parentName="ul"><strong parentName="li">{`Yellow`}</strong>{` for points on the vertical bar and show all button`}</li>
    </ul>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><Link to="/eu/components/list/usage/" mdxType="Link">Ordered list</Link></li>
      <li parentName="ul"><Link to="/eu/components/list/usage/" mdxType="Link">Unordered list</Link></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;